import { ConfirmDeleteTarget } from "models/ConfirmDeleteTarget";
import { ParticipantDetailModel } from "models/ParticipantDetailModel";
import { createContext } from "react";

export interface ParticipantContextProps {
  selectParticipantId: number;
  setSelectParticipantId: (id: number) => void;
  confirmDeleteParticipant: ConfirmDeleteTarget | undefined;
  setConfirmDeleteParticipant: (target: ConfirmDeleteTarget | undefined) => void;
  onParticipantSortEnd: (oldIndex: number, newIndex: number) => void;
  allowDrag: boolean;
  participants: ParticipantDetailModel[] | undefined;
  setParticipants: (participants: ParticipantDetailModel[] | undefined) => void;
  isParticipantUpdating: (id: number) => boolean;
  setParticipantUpdating: (id: number, newState: boolean) => void;
  isParticipantDeleting: (id: number) => boolean;
  setParticipantDeleting: (id: number, newState: boolean) => void;
}

export const ParticipantContext = createContext({} as ParticipantContextProps);
